var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGooseFeet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.829 5.976c.64.48 1.4.24 2.28-.04 1-.32 1.56-.44 1.96 0 .36.44.12.96-.44 1.88-.52.8-.88 1.68-.52 2.36.32.64.92.84 1.4 1 .6.16 1 .28 1.12.64.16.4-.12 1.16-1.84 1.84-1.76.68-4.8 1.48-6.68 1.76-2.16.32-3.96.6-4.88-.56-.88-1.12-.12-2.84.52-4.2.76-1.64 2.44-4.6 3.8-6.4 1.32-1.76 2.08-1.8 2.48-1.56.48.28.28 1.04.24 1.52-.04.56-.04 1.32.56 1.76zM10.589 18.216c.64.48 1.4.24 2.28-.04 1-.32 1.56-.44 1.96 0 .36.44.12.96-.44 1.88-.52.8-.88 1.68-.52 2.36.32.64.92.84 1.4 1 .6.16 1 .28 1.12.64.16.4-.12 1.16-1.84 1.84-1.72.68-4.8 1.52-6.68 1.8-2.16.32-3.96.6-4.88-.56-.88-1.12-.12-2.84.52-4.16.76-1.64 2.44-4.6 3.8-6.4 1.32-1.76 2.08-1.8 2.48-1.56.48.28.32 1 .28 1.52-.08.52-.08 1.24.52 1.68z",
    fill: "#FF794F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.189 14.616c-.84-1.68 1.16-5.68 3.08-8.56.36-.52.68-1 1-1.4M13.91 26.176c-3.16 1.24-9.081 2.68-10.681 1.2",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.469 18.536c2.44.2 4.96-.56 6.88-2.12M7.029 12.536c-1.96 1.48-3.32 3.76-3.72 6.2",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgGooseFeet;